<template>
  <div :data-testid="dataTestid">
    <div
      class="px-4 bg-semantic-inverse-surface text-white pt-8 md:pt-[4.4375rem] pb-14 md:pb-[4.9375rem] -mt-6 -mx-4 md:mt-0 md:mx-0"
    >
      <div class="max-w-wrapper-sm2 mx-auto flex flex-col justify-center">
        <p
          class="text-[1.83rem]/[2.25rem32] md:text-5xl text-center mb-[0.5625rem] md:mb-[1.875rem]"
        >
          Join Hundreds of <br class="md:hidden" />Thousands of Aussies: <br />
          <span class="font-extrabold">
            Save $300* on Your <br class="md:hidden" />Health Insurance
          </span>
        </p>

        <p class="text-[0.975rem] md:text-2xl mb-[1.875rem] text-center">
          Compare Australia's top health insurers in<br class="md:hidden" />
          minutes
        </p>

        <div
          class="grid grid-cols-3 md:grid-cols-7 gap-[0.875rem] text-dark mb-[2.0625rem] md:mb-[3.125rem] max-w-[18.125rem] md:max-w-none mx-auto"
        >
          <div
            v-for="(partner, index) in _PARTNERS"
            :key="index"
            class="bg-white py-[0.8125rem] flex items-center justify-center rounded-2md border-1 border-gray-210 h-14 md:h-auto"
            :class="{
              'px-[0.5625rem]': partner.company !== 'Peoplecare.svg',
            }"
          >
            <img
              :src="`/icons/health-insurance/company-logos/${partner.company}`"
              alt="Partner logo"
              class="max-w-full max-h-full"
            />
          </div>

          <div
            class="bg-white py-[0.8125rem] hidden md:flex items-center justify-center px-[0.5625rem] rounded-2md border-1 border-gray-210 relative text-[#666666]"
          >
            <RouterLink
              to="/health-insurance/companies/"
              class="absolute top-0 bottom-0 left-0 right-0"
            />
            + more
          </div>
        </div>

        <atoms-button
          class="!text-2xl !pt-[0.5625rem] !pb-[0.625rem] w-[20.625rem] mx-auto max-w-full shadow-[0.25rem_0.5625rem_0.6875rem_#0000003D]"
          theme="primary"
          to="/health-insurance/quote/form/step1/"
          inverted
        >
          <span> Get quote </span>
        </atoms-button>
      </div>
    </div>
    <div
      v-if="['Article3Column-D2', 'Article3Column-D3'].includes(props.variant)"
      class="py-5 md:py-[29px]"
      :class="{ 'border-b-1': props.variant === 'Article3Column-D2' }"
    >
      <MoleculesTrustpilot />
    </div>
    <div v-if="props.variant === 'Article3Column-D3'" class="-mx-4 md:mx-0">
      <V2MoleculesHomeDirectPrice title="Lowest Price Guarantee">
        <template #description>
          Our Lowest Price Guarantee means that even if you could find the same
          policy for cheaper elsewhere, we’ll give you one months premium free
        </template>
      </V2MoleculesHomeDirectPrice>
    </div>
  </div>
</template>

<script setup>
import { PARTNER_ITEMS } from '~/constants/pages/health-insurance'

defineOptions({
  name: 'MoleculesVerticalPostHero'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'vertical-post-hero'
  },

  variant: {
    type: String,
    default: 'Article3Column-D1'
  }
})

const _PARTNERS = PARTNER_ITEMS.filter(e => e.company !== 'Latrobe.svg')
</script>
